module.exports = __webpack_public_path__ + "media/home2-right.0dae5d44.mp4";